/**
 * Радио-кнопки, переключающие табы
 */
export default () => {
    const $tabBody = $('.js-radio-tab-body');
    // Проставления атрибута исключения parsley
    const setParsleyIgnore = tabItem => {
        const $tabItem = $(tabItem);
        const $fields = $tabItem.find('input, textarea');

        if (!$tabItem.hasClass('is-visible')) {
            $fields.each((fieldIndex, field) => $(field).attr('data-parsley-excluded', 'true'));
        } else {
            $fields.each((fieldIndex, field) => $(field).removeAttr('data-parsley-excluded'));
        }
    };

    // Проставляем атрибуты исключения parsley при загрузке страницы
    $tabBody.each((i, item) => setParsleyIgnore(item));

    $(document).on('click', '.js-radio-tab', ({ currentTarget }) => {
        const $radio = $(currentTarget);
        const $tab = $($radio.attr('data-tab-target'));

        $tabBody.removeClass('is-visible');
        $tab.addClass('is-visible');

        // После открытия таба, проставляем исключения
        $tabBody.each((i, item) => setParsleyIgnore(item));
    });
};
